export enum OrderStatus {
  Paid = 'paid',
  Partial = 'partial',
  Unpaid = 'unpaid',
  Cancelled = 'cancelled',
  Void = 'voided'
}

export enum PaymentMode {
  Prepaid = 'Prepaid',
  Postpaid = 'Postpaid',
  PayAtTable = "Pay at table"
}

export enum VoucherType {
  Amount = 'amount',
  Percentage = 'percentage'
}

export enum ItemStatus {
  Enabled = 'e',
  ReadOnly = 'r',
  Unavailable = 'u',
}

export enum MenuAction {
  Waiter = 'call_waiter',
  Orders = 'orders',
  Bill = 'bill',
  Whatsapp = 'whatsapp',
  Directory = 'directory',
  Custom = 'custom'
}

export enum PaymentType {
  Card = 'card',
  Cash = 'cash',
  Room = 'room'
}

export enum VoucherMode {
  Single = 'single',
  Balance = 'balance',
  Multi = 'multi'
}

export enum VenueType {
  Default = 'Default',
  ReadOnly = 'Read only',
}

export enum NotificationType {
  BringTheBill = 'bring_the_bill',
  CallWaiter = 'call_waiter'
}

export enum StoredItem {
  Language = 'LANGUAGE',
  Currency = 'CURRENCY',
  OrderForm = 'USER-FORM-DATA'
}

export enum MenuDisplayMode {
  UserSelect = 'user_select',
  Grid = 'grid_only',
  List = 'list_only'
}

// Single source of truth for which languages render right-to-left.
export const RTL_LANGUAGES: readonly string[] = ['ar', 'fa'];

